import React, { useContext } from 'react'
import './GroupEventCard.css'
import { Button, Row, Col } from 'reactstrap'
import EventCard from './EventCard'
import { SPContext } from '../../SPContext'
import moment from 'moment'

const dateIsNull = date => date === '0000-00-00 00:00:00'
const sortNewest = (a, b) => {
    if (a.id > b.id) {
        return 1
    } else {
        return -1
    }
    // return moment.utc(a.event_created_at).diff(moment.utc(b.event_created_at))
}
const sortEndingFirst = (a, b) => {
    const a_date = a.event_date_end || a.event_date_start
    const b_date = b.event_date_end || b.event_date_start
    if (dateIsNull(a_date) && dateIsNull(b_date)) {
        return (a.event_id > b.event_id && 1) || -1
    } else if (dateIsNull(a_date)) {
        return 1
    } else if (dateIsNull(b_date)) {
        return -1
    }
    return moment.utc(a_date).diff(moment.utc(b_date)) || 0
}
const sortComingUp = (a, b) => {
    if (dateIsNull(a.event_date_start) && dateIsNull(b.event_date_start)) {
        return (a.event_id < b.event_id && 1) || -1
    } else if (dateIsNull(a.event_date_start)) {
        return -1
    } else if (dateIsNull(b.event_date_start)) {
        return 1
    }
    return moment.utc(a.event_date_start).diff(moment.utc(b.event_date_start)) || 0
}

const sortPopular = (a, b) => {
    if (a.likes.length + a.going.length > b.likes.length + b.going.length) {
        return -1
    } else if (a.likes.length + a.going.length < b.likes.length + b.going.length) {
        return 1
    } else {
        return 0
    }
}
const sortGoing = (a, b) => {
    if (a.going.length > b.going.length) {
        return -1
    } else if (a.going.length < b.going.length) {
        return 1
    } else {
        return 0
    }
}
const sortRating = (a, b) => {
    if (a.event_rating > b.event_rating) {
        return 1
    } else if (a.event_rating < b.event_rating) {
        return -1
    } else {
        return 0
    }
}

function GroupEventCard({ section, number_of_events }) {
    const { events, filter, sort, page, setPage, inAdminPage, user_data } = useContext(SPContext)
    // console.log({ events })

    const max_events = page * number_of_events

    const main_title = [{ title: 'Ending soon' }, { title: 'Latest' }, { title: 'Most popular' }]

    const nextPage = () => {
        setPage(page + 1)
    }

    const getFilteredEvents = lc_events => {
        if (!inAdminPage) {
            lc_events = lc_events.filter(e => {
                return (
                    e.event_FK_event_status_id === '2' ||
                    (filter.status && filter.status.includes(e.event_FK_event_status_id)) ||
                    (user_data &&
                        parseInt(e.event_FK_created_by_user_id, 10) ===
                            parseInt(user_data.user_id, 10))
                )
            })
        }

        if (section !== 'filter') {
            return lc_events
        }
        if (filter) {
            if (filter.categories && filter.categories.length && filter.categories[0] !== '') {
                lc_events = lc_events.reduce((acc, item) => {
                    if (
                        filter.categories.reduce((cat_acc, category_id) => {
                            return (
                                cat_acc ||
                                item.categories.find(cat => cat.category_id === category_id)
                            )
                        }, false)
                    ) {
                        acc.push(item)
                    }
                    return acc
                }, [])
            }
            if (filter.location_label) {
                lc_events = lc_events.reduce((acc, item) => {
                    if (item.location_label === filter.location_label) {
                        acc.push(item)
                    }
                    return acc
                }, [])
            }
            if (filter.liked_by) {
                lc_events = lc_events.reduce((acc, item) => {
                    if (item.likes && ~item.likes.indexOf(parseInt(filter.liked_by))) {
                        acc.push(item)
                    }
                    return acc
                }, [])
            }
            if (filter.going_to) {
                lc_events = lc_events.reduce((acc, item) => {
                    if (item.going && ~item.going.indexOf(parseInt(filter.going_to))) {
                        acc.push(item)
                    }
                    return acc
                }, [])
            }
            if (filter.status && filter.status.length && filter.status[0] !== '') {
                lc_events = lc_events.reduce((acc, item) => {
                    if (
                        filter.status.reduce((status_acc, event_status_id) => {
                            return status_acc || item.event_FK_event_status_id === event_status_id
                        }, false)
                    ) {
                        acc.push(item)
                    }
                    return acc
                }, [])
            }

            if (filter.search && filter.search.length >= 3) {
                lc_events = lc_events.filter(
                    e =>
                        !!~e.event_title
                            .toLocaleLowerCase()
                            .indexOf(filter.search.toLocaleLowerCase()) ||
                        !!~e.event_description_value
                            .toLocaleLowerCase()
                            .indexOf(filter.search.toLocaleLowerCase()) ||
                        !!~e.event_summary_value
                            .toLocaleLowerCase()
                            .indexOf(filter.search.toLocaleLowerCase()),
                )
            }
        }
        sort === 'RATING' && lc_events.sort(sortRating)
        sort === 'NEWEST' && lc_events.sort(sortNewest)
        sort === 'ENDING_FIRST' && lc_events.sort(sortEndingFirst)
        sort === 'COMING_UP' && lc_events.sort(sortComingUp)
        sort === 'POPULAR' && lc_events.sort(sortPopular)
        sort === 'GOING' && lc_events.sort(sortGoing)
        return lc_events
    }

    let lc_events = getFilteredEvents([...events])

    return (
        <div className='topevents-container pb-5'>
            <div className='container'>
                {!lc_events.length &&
                    section === 'filter' &&
                    'There are no events matching your criteria'}
                <div className='row sp-group-card pt-5'>
                    {lc_events.slice(0, max_events).map((event, index) => (
                        <EventCard
                            key={'card_' + event.event_id}
                            main_title={(section === 'main' && main_title[index]) || ''}
                            section={section}
                            item_event={event}
                        />
                    ))}
                </div>
                {(section === 'filter' && (
                    <Row className='sp-group-card-buttons'>
                        <Col sm={{ size: 12 }}>
                            <div className='standard-button text-center'>
                                {(max_events < lc_events.length && (
                                    <Button
                                        color='primary'
                                        className='mt-5 d-inline-block'
                                        onClick={nextPage}
                                    >
                                        Load more
                                    </Button>
                                )) ||
                                    null}
                            </div>
                        </Col>
                    </Row>
                )) ||
                    ''}
            </div>
        </div>
    )
}

export default GroupEventCard
